import type { MarketVariants } from '@/lib/i18n'

export type LockAction = { title: string; detail: string }

export type Slide5LockAccountsCopy = {
  eyebrow: string
  title: string
  body: string
  /** Numbered list. Rendered in order; the number is added at render time. */
  actions: LockAction[]
}

const usActions: LockAction[] = [
  {
    title: 'Change your password.',
    detail:
      'Start with your email. Then banking, then anything else that uses the same password.',
  },
  {
    title: 'Turn on two-factor authentication.',
    detail:
      'Even if a scammer has your password, this second lock still holds.',
  },
  {
    title: 'Sign out of every device.',
    detail:
      'Look for “sign out everywhere” in your account settings. This kicks the scammer out if they have already logged in.',
  },
]

export const copy: MarketVariants<Slide5LockAccountsCopy> = {
  US: {
    eyebrow: 'Step three',
    title: 'If details were shared.',
    body: 'If you shared a password, a code, or login details, lock down those accounts now before scammers can use them.',
    actions: usActions,
  },
  QA: {
    // Qatar has no credit bureau freeze. The local equivalents are the
    // e-government logins (Metrash2) and asking the bank to flag accounts
    // and the QID, so the list gains a fourth step.
    actions: [
      {
        title: usActions[0].title,
        detail:
          'Start with your email. Then banking, then Metrash2 and any other government logins, then anything else that uses the same password.',
      },
      usActions[1],
      usActions[2],
      {
        title: 'Tell your bank if your QID was shared.',
        detail:
          'Ask them to flag your accounts and your Qatar ID (QID) for fraud, so nobody can use them to open accounts or move money in your name.',
      },
    ],
  },
  ar: {
    eyebrow: 'الخطوة الثالثة',
    title: 'إذا شاركت بياناتك.',
    body: 'إذا شاركت كلمة مرور أو رمز تحقق أو بيانات تسجيل الدخول، فأغلق تلك الحسابات الآن قبل أن يستخدمها المحتالون.',
    actions: [
      {
        title: 'غيّر كلمة المرور.',
        detail:
          'ابدأ ببريدك الإلكتروني، ثم الحسابات البنكية، ثم مطراش2 وأي حسابات حكومية أخرى، ثم أي حساب آخر يستخدم كلمة المرور نفسها.',
      },
      {
        title: 'فعّل التحقق بخطوتين.',
        detail:
          'حتى لو حصل المحتال على كلمة مرورك، يبقى هذا القفل الثاني صامداً.',
      },
      {
        title: 'سجّل الخروج من جميع الأجهزة.',
        detail:
          'ابحث عن خيار "تسجيل الخروج من جميع الأجهزة" في إعدادات حسابك. هذا يُخرج المحتال إذا كان قد سجّل الدخول بالفعل.',
      },
      {
        title: 'أخبر بنكك إذا شاركت رقم بطاقتك الشخصية.',
        detail:
          'اطلب منهم وضع إشارة تحذير من الاحتيال على حساباتك وبطاقتك الشخصية القطرية، حتى لا يتمكن أحد من استخدامها لفتح حسابات أو تحويل أموال باسمك.',
      },
    ],
  },
}
